import { mergeWith } from "lodash"
import { HOSTS } from "@/constants/environment"

interface ForceHideMenu {
  readonly forceHideHeader: string[]
  readonly forceHideMenu: string[]
  readonly [index: string]: string[]
}

export const target: ForceHideMenu = {
  forceHideHeader: [],
  forceHideMenu: ["/401"],
}

export const cms: ForceHideMenu = {
  forceHideHeader: [],
  forceHideMenu: [],
}

function mergeUrlMap(target: ForceHideMenu, cms: ForceHideMenu): any {
  const handleBaseUrl = (everySystemMap: ForceHideMenu, baseUrl: string) =>
    Object.entries(everySystemMap).reduce((map, [key, urls]) => {
      return {
        ...map,
        [key]: urls.map((item) => `${baseUrl}${item}`),
      }
    }, {})

  return mergeWith(
    {},
    handleBaseUrl(target, HOSTS.TARGET),
    handleBaseUrl(cms, HOSTS.CMS),
    (objValue: any, srcValue: any) => {
      if (Array.isArray(objValue)) {
        return objValue.concat(srcValue)
      }
    },
  )
}

export const mergedForceHideMenuMap: ForceHideMenu = mergeUrlMap(target, cms)
